export default __webpack_public_path__ + "static/screenshot-mybiz-1-cabb0e19b0a9233c398f9d0ac2d78e3d.jpg";